import React, { useState, useRef, useEffect } from 'react';

// libraries
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSTransition } from 'react-transition-group';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';

// utils
import useMediaQuery from './useMediaQuery';

const Para2 = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.6;
  color: #ef629f;
  @media all and (max-width: 1024px) {
    font-size: 0.8rem;
  }
`;

const DropdownContainer = styled.div`
  position: absolute;
  top: 100px;
  width: 200px;
  transform: translateX(50%);
  background-color: #fff5f9;
  overflow: hidden;
  transition: height 500ms ease;
  @media (max-width: 769px) {
    top: 355px;
    transform: translateX(0%);
  }
  .menu-primary-enter {
    position: absolute;
    transform: translateX(-110%);
  }
  .menu-primary-enter-active {
    transform: translateX(0%);
    transition: all 500ms ease;
  }
  .menu-primary-exit {
    position: absolute;
  }
  .menu-primary-exit-active {
    transform: translateX(-110%);
    transition: all 500ms ease;
  }

  .menu-secondary-enter {
    transform: translateX(110%);
  }
  .menu-secondary-enter-active {
    transform: translateX(0%);
    transition: all 500ms ease;
  }

  .menu-secondary-exit-active {
    transform: translateX(110%);
    transition: all 500ms ease;
  }
`;

const Menu = styled.div`
  width: 100%;
  .link {
    text-decoration: none;
  }
`;

const MenuItem = styled.div`
  height: 50px;
  display: flex;
  color: #ef629f;
  justify-content: space-between;
  align-items: center;
  transition: background 500ms;
  padding: 0.5rem;
  &:hover {
    background-color: #fac3d9;
    cursor: pointer;
  }
  .link {
    text-decoration: none;
  }
  .text {
    margin-left: 5px;
    @media (max-width: 769px) {
      font-style: normal;
      font-weight: normal;
      font-size: 1rem;
      line-height: 1.6;
      color: #ef629f;
    }
  }
`;

function DropdownItem({
  children,
  link,
  haveChildren,
  handler,
  toggleMenuOpen,
  mobile,
}) {
  const clickEvents = () => {
    if (!haveChildren) {
      handler();
      if (mobile) {
        toggleMenuOpen();
      }
    }
  };
  return (
    <MenuItem onClick={clickEvents}>
      <Link className="link" to={link}>
        <Para2 className="text">{children}</Para2>
      </Link>
      {haveChildren && <FontAwesomeIcon icon={faAngleRight} />}
    </MenuItem>
  );
}

function Dropdown({ data, handler, open, setOpen, toggleMenuOpen, mobile }) {
  const [activeMenu] = useState('main');
  const [menuHeight, setMenuHeight] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setMenuHeight(dropdownRef.current?.firstChild.offsetHeight);
  }, []);

  const isDesktop = useMediaQuery('(min-width: 769px)');

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        open &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    if (isDesktop) {
      document.addEventListener('mousedown', checkIfClickedOutside);
    }
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [open, setOpen, isDesktop]);

  const calcHeight = (el) => {
    const height = el.offsetHeight;
    setMenuHeight(height);
  };

  return (
    <DropdownContainer style={{ height: menuHeight }} ref={dropdownRef}>
      <CSSTransition
        in={activeMenu === 'main'}
        timeout={500}
        classNames="menu-primary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <Menu>
          {data.map(({ name, link }) => (
            <DropdownItem
              key={link}
              link={link}
              handler={handler}
              toggleMenuOpen={toggleMenuOpen}
              mobile={mobile}
              haveChildren
            >
              {name}
            </DropdownItem>
          ))}
        </Menu>
      </CSSTransition>
    </DropdownContainer>
  );
}

export default Dropdown;
